import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { MachineScheduleViewModel } from 'chronos-core-client';

export type ProductionOrderListState = EntityState<MachineScheduleViewModel> & { hasData: boolean };

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'production-order-list', idKey: 'productionOrderId', resettable: true })
export class ProductionOrderListStore extends EntityStore<ProductionOrderListState, MachineScheduleViewModel> {
  constructor() {
    super({ hasData: true });
  }

  public setHasData(hasData: boolean): void {
    this.update((state) => ({ ...state, hasData }));
  }
}
